import React from "react"

const agedata = [
    {
        "Date": "25-Nov",
        "data": 5924,
    },
    {
        "Date": "25-Nov",
        "data": 7051,
    },
    {
        "Date": "25-Nov",
        "data": 5740,
    },
    {
        "Date": "25-Nov",
        "data": 4633,
    },
    {
        "Date": "25-Nov",
        "data": 4803,
    },
    {
        "Date": "25-Nov",
        "data": 3198,
    },
    {
        "Date": "25-Nov",
        "data": 1544,
    },
    {
        "Date": "25-Nov",
        "data": 1113,
    },
    {
        "Date": "30-Dec",
        "data": 9814,
    },
    {
        "Date": "30-Dec",
        "data": 9907,
    },
    {
        "Date": "30-Dec",
        "data": 8822,
    },
    {
        "Date": "30-Dec",
        "data": 7895,
    },
    {
        "Date": "30-Dec",
        "data": 8695,
    },
    {
        "Date": "30-Dec",
        "data": 6156,
    },
    {
        "Date": "30-Dec",

        "data": 3121,
    },
    {
        "Date": "30-Dec",
        "data": 2441,
    },
    {
        "Date": "20-Jan",
        "data": 14574,
    },
    {
        "Date": "20-Jan",
        "data": 13575,
    },
    {
        "Date": "20-Jan",
        "data": 11078,
    },
    {
        "Date": "20-Jan",
        "data": 9895,
    },
    {
        "Date": "20-Jan",
        "data": 10723,
    },
    {
        "Date": "20-Jan",
        "data": 7173,
    },
    {
        "Date": "20-Jan",
        "data": 3732,
    },
    {
        "Date": "20-Jan",
        "data": 2797,
    },
]

export default agedata;
